import { useRef, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { Button } from '@nazka/nazka.mapframe.components';
import { faUser } from '@fortawesome/pro-light-svg-icons';
import { NavLink } from 'react-router-dom';

import { useTranslation } from '@utils/i18n/i18n.consumers';
import { useOnClickOutside } from '@services/hooks.service';

import './admin-navbar.styl';

function AdminNavbar() {
  const menuRef = useRef();

  const [showUserMenu, setShowUserMenu] = useState(false);

  const { user, signoutRedirect } = useAuth();
  const { t } = useTranslation();

  useOnClickOutside(menuRef, () => setShowUserMenu(false));

  return (
    <div className="admin-navbar">
      <NavLink to="/">
        <img src="/img/logo/climate-champions-logo.svg" alt="logo" />
      </NavLink>
      <div className="admin-navbar__buttons">
        {/* <Button layout="outlined" hover={false}>
          {t('Help')}
        </Button> */}
        <div className="admin-navbar__user" ref={menuRef}>
          <Button
            layout="outlined"
            icon={faUser}
            css={{ flexDirection: 'row-reverse' }}
            onClick={() => setShowUserMenu(prev => !prev)}
            hover={false}
          >
            {`${user?.profile?.given_name} ${user?.profile?.family_name}`}
          </Button>
          {showUserMenu && (
            <div className="admin-navbar__user__menu z-depth-1">
              <Button
                className="admin-navbar__user__menu__item"
                layout="ghost"
                hoverColor="#eee"
                onClick={async () => {
                  await signoutRedirect({
                    extraQueryParams: {
                      client_id: import.meta.env.VITE_COGNITO_CLIENT_ID,
                      logout_uri: `${window.location.origin}/admin`,
                    },
                  });
                }}
              >
                {t('Log out')}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminNavbar;